import { Collapse, UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap'
import Lazyload from 'react-lazy-load'
import Testimonials from "./TestimonialsHome"
import {Trans, useTranslation, useI18next} from 'gatsby-plugin-react-i18next';
import { useLocation } from '@reach/router';

const MentalHealthChallenges = () => {
    const location = useLocation();
    const { pathname } = location;
    const { t } = useTranslation();
    return (
    <>
        <section className="bg-dark multi-activity hero-bg position-relative section-pdn pt-8 soln-hero mhc-1">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12">
                    <h1 className="font-weight-semibold hero-heading text-center">
                        <Trans>Ascend to Well-Being</Trans>
                    </h1>
                    <p className="hero-para font-weight-normal text-center no-br">
                        <Trans>Empower your employees with resources and initiatives <br/>to nurture their emotional wellness.</Trans>
                    </p>
                    <div className="pl-0 pr-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Book a Demo</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>
        <section className="position-relative pb-0 vfitsoln ge-2">
            <div className="feat_box sect-white-col-2 shadow feat_pb0 mb-0">
                <div className="d-flex m-d-block container custom_container p0">
                    <div className="col-12 col-md-6 p-0">
                        <div className="col-12 p-0">
                            <h2 className='font-weight-semibold py-2 section-heading green-text'><Trans>Looking for a holistic approach that combines <span>physical</span> and <span>mental</span> wellness?</Trans></h2>
                            <p className='section-para font-weight-normal'><Trans>Vantage Fit seamlessly integrates mental health resources with physical wellness initiatives,for a comprehensive approach.</Trans></p>
                        </div>
                    </div>
                    <div className='cta-img'>
                        <div className='d-flex justify-content-center'>
                            <img loading="lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/v1699963463/VantageFit/2023/Mental_Health___Well-being-painpoint.webp" alt="Looking for a holistic approach that combines physical and mental wellness?" width="635" height="688"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative pl-0 pr-0">
            <div className="">
                <h2 className="section-heading section-heading-top font-weight-semibold text-center no-br"><Trans>Embark on a Journey Towards Mental Wellbeing.</Trans></h2>
                <div className="">
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Mindfulness and Meditation Sessions</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Guided sessions to help employees find calm and reduce stress.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Provide guided mindfulness and meditation to promote tranquility.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Assist employees in finding calm and reducing stress through guided sessions.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Offer sessions aimed at cultivating mindfulness and easing stress.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1703070000/VantageFit/2023/Mental_Health_Well-being-Mindfulness_and_Meditation_Sessions.webp`)} loading='lazy' alt="Mindfulness and Meditation Sessions" width="668" height="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Multi-Mental Health Resources</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Curated articles, webinars and expert talks on various topics related to emotional well-being.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Offer curated articles, webinars, and expert talks covering emotional well-being.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Provide your employees a range of resources addressing various aspects of mental health.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Ensure employees have the means to seek professional advice and assistance when needed.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1703070015/VantageFit/2023/Mental_Health_Well-being-Multi-Mental_Health_Resources.webp`)} loading='lazy' alt="Multi-Mental Health Resources" width="601" height="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Guidance and Support</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Connect employees to professional counselors or helplines when needed.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Link employees to professional counselors or helplines as needed.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Provide access to counseling resources for immediate support.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Connect employees with professional help when guidance and support are required.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1699963464/VantageFit/2023/Mental_Health___Well-being-Guidance_and_support.webp`)} loading='lazy' alt="Guidance and Support" width="565" height="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Mood Logging and Tracking</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Allow employees to track their mood, providing insights into their emotional health over time.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Enable employees to log and track their mood for self-awareness.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Gain a better understanding of emotional well-being through mood tracking.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Offer a tool for employees to observe and manage their mood patterns over time.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1703070002/VantageFit/2023/Mental_Health_Well-being-Mood_Logging_and_Tracking.webp`)} loading='lazy' alt="Mood Logging and Tracking" width="581" height="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="gray-gradient-bg section-pdn-1">
            <div className="container custom_container mx-auto relative">
                <div className="px-5">
                    <h2 className="section-heading text-center pt-0">
                    <Trans>Real people, real results</Trans>
                    </h2>
                    <p className="col-12 sub-para text-center f-400 mt-0 mb-5 pb-5">
                    <Trans>Vantage Fit speaks for itself, but our
                        customer reviews speak even louder.</Trans>
                    </p>
                    <div className="col-lg-12 testimonialcarousel d-none d-md-flex mb-0 p-5">
                        <div className="testi_profile">
                            <div className="testi_profile_image"><img src="https://res.cloudinary.com/vantagecircle/image/upload/v1700137313/VantageFit/2023/elsa_Robertson.webp" alt="Elsa Robertson" className="max-w lozad" width="218" height="218" loading="lazy"/></div>
                            <div className="testi_profile_name p-4">
                                <h3 className="font-weight-bold text-center text-lg-left text-white mb-0">Elsa Robertson</h3>
                                <p className="font-weight-light text-center text-lg-left text-white mb-0"><Trans>Senior Associate at Heidrick & Struggles, Australia</Trans></p>
                            </div>
                        </div>
                        <div className="d-flex flex-column flex-lg-row justify-content-around align-items-center ">
                            <div className="col-12 col-md-11 d-flex flex-column">
                                <p className="section-para text-center text-lg-left mb-0"><Trans>The <span>Vantage Fit</span> app is an effective tool for corporate walking challenges, offering a range of features to help participants stay motivated and connected throughout the challenge.</Trans></p>
                            </div>
                        </div>
                    </div>
                    <div className="d-md-none d-block p-3" style={{ background: 'white', boxShadow: '1px 0px 20px rgba(0,0,0,0.3)', borderRadius: '25px' }}>
                        <div className="p-2" style={{ background: '#1d2227', borderRadius: '40px', display: 'grid', justifyContent: 'center' }}>
                            <img style={{ marginLeft: '0.5rem !important', marginTop: '0.5rem', marginBottom: '1rem' }} src="https://res.cloudinary.com/vantagecircle/image/upload/v1700218240/VantageFit/2023/elsa_Robertson.webp" alt="Elsa Robertson" className="mx-auto" width="218" height="218" loading="lazy"/>
                            <h3 className="font-weight-bold text-center text-white mb-0">Elsa Robertson</h3>
                            <p className="font-weight-light text-center text-white my-3"><Trans>Senior Associate at Heidrick & Struggles, Australia</Trans></p>
                        </div>
                        <p className="section-para text-center text-lg-left my-4"><Trans>The <span>Vantage Fit</span> app is an effective tool for corporate walking challenges, offering a range of features to help participants stay motivated and connected throughout the challenge.</Trans></p>

                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative section-pdn-1 pl-0 pr-0 faq-wrapper">
            <div className="logo-container">
                <h2 className="section-heading mb-5 no-br clr49 font-weight-bold">FAQ</h2>
                <div id="accordion" className="">
                    <Card>
                        <Button id="faq1">
                            <Trans>How do you ensure the privacy of employees using mental health resources?</Trans>
                        </Button>
                        <UncontrolledCollapse toggler="#faq1">
                            <CardBody>
                                <Trans>Vantage Fit doesn't require specific employee details for granting access to mental health sessions, eliminating the potential security concerns. However, if you utilize a partner service via Vantage Fit, the security of employee information is contingent on the terms and conditions established by the selected partner.</Trans>
                            </CardBody>
                        </UncontrolledCollapse>
                    </Card>
                    <Card>
                        <Button id="faq2">
                            <Trans>What are the different categories present for mental health and wellbeing present in Vantage Fit?</Trans>
                        </Button>
                        <UncontrolledCollapse toggler="#faq2">
                            <CardBody>
                                <Trans>Vantage Fit offers mental health and well-being via a variety of categories, allowing users to select from categories such as meditation, sleep improvement, self-awareness, and relaxation through mindfulness sessions.</Trans>
                            </CardBody>
                        </UncontrolledCollapse>
                    </Card>
                    <Card>
                        <Button id="faq3">
                            <Trans>Does Vantage Fit provide partner services for mental health & wellbeing.</Trans>
                        </Button>
                        <UncontrolledCollapse toggler="#faq3">
                            <CardBody>
                                <Trans>Yes, Vantage Fit provides partner services for mental health & wellbeing.</Trans>
                            </CardBody>
                        </UncontrolledCollapse>
                    </Card>
                </div>
            </div>
        </section>

        <section className="mhc-btm ctabtm multi-activity hero-bg position-relative section-pdn-1 pt-8 feat_testi brad0">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12">
                    <h2 className="font-weight-semibold section-heading text-center no-br">
                        <Trans>Ready to Elevate Your Organization's <br/>Mental Well-being?</Trans>
                    </h2>
                    <p className="sub-para font-weight-normal text-center mb-5">
                        <Trans>Join the wellness revolution with Vantage Fit.</Trans>
                    </p>
                    <div className="pl-0 pr-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Book a Demo</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>

    </>
  )
}

export default MentalHealthChallenges
